import React from "react";
import { PoolProps } from "@/types/modules/post/contentComponents";
import { Text } from "@/components/ui-kit/Text";
import Image from "next/image";

export const Pool: React.FC<PoolProps> = ({ name, jobTitle, bio, photo }) => {
  return (
    <div className="mb-8 flex items-center justify-between border-b border-t border-dotted border-dark-70 py-4">
      <div className="flex flex-col font-sans">
        <h2 className="text-lg dark:text-white">{name}</h2>
        <p className="mt-0 text-xs font-light dark:text-white-70">{jobTitle}</p>
        <p className="mt-2 pr-8 text-sm font-light dark:text-white sm:pr-2">
          <Text>{bio}</Text>
        </p>
      </div>
      {photo && <Image src={photo} alt={name} width={80} height={112} className="h-28 w-20 object-contain" />}
    </div>
  );
};
